import { m as textSeparator, o as opportunities, n as clock, p as calendarAlt, q as angleDoubleRight, r as angleDoubleLeft, v as search, w as ellipsisV, x as amznAdsStormLogo, i as infoCircle, g as angleDown, f as angleUp, y as angleRight, z as angleLeft, c as check, e as exclamationTriangle, a as exclamation, A as externalLinkAlt, t as times } from '../localIcons-sBnDaVj5-23EprBeB.js';

const commonIconManifest = {
  times: times.icon,
  'external-link-alt': externalLinkAlt.icon,
  exclamation: exclamation.icon,
  'exclamation-triangle': exclamationTriangle.icon,
  check: check.icon,
  spinner: [512, 512, [], 'f110', 'M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z'],
  'angle-left': angleLeft.icon,
  'angle-right': angleRight.icon,
  'angle-up': angleUp.icon,
  'angle-down': angleDown.icon,
  'info-circle': infoCircle.icon,
  'amzn-ads-storm-logo': amznAdsStormLogo.icon,
  'ellipsis-v': ellipsisV.icon,
  search: search.icon,
  'angle-double-left': angleDoubleLeft.icon,
  'angle-double-right': angleDoubleRight.icon,
  'calendar-alt': calendarAlt.icon,
  clock: clock.icon,
  opportunities: opportunities.icon,
  'text-separator': textSeparator.icon
};

export { commonIconManifest as c };
//# sourceMappingURL=commonIconManifest-By2ZPRhm-C0SCtHSy.js.map
